// @flow

function labelToId(label: string): string {
  return label
    .split(' ')
    .join('-')
    .toLowerCase();
}

export default labelToId;
